import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import './react-v49.css';

createRoot(document.getElementById('root')!).render(
 <StrictMode><BrowserRouter><LanguageProvider><AuthProvider><App/></AuthProvider></LanguageProvider></BrowserRouter></StrictMode>
);
